import React, { useState } from 'react';
import styled from 'styled-components';

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipText = styled.div<{ $visible: boolean; $position: string }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  width: 220px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 10;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.3s;
  
  /* Positioning */
  ${({ $position }) => {
    switch ($position) {
      case 'bottom':
        return `
          top: 125%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return `
          top: 50%;
          right: 105%;
          transform: translateY(-50%);
        `;
      case 'right':
        return `
          top: 50%;
          left: 105%;
          transform: translateY(-50%);
        `;
      default: // top
        return `
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
        `;
    }
  }}
  
  /* Arrow */
  &::after {
    content: '';
    position: absolute;
    
    ${({ $position }) => {
      switch ($position) {
        case 'bottom':
          return `
            bottom: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: transparent transparent #555 transparent;
          `;
        case 'left':
          return `
            top: 50%;
            left: 100%;
            margin-top: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: transparent transparent transparent #555;
          `;
        case 'right':
          return `
            top: 50%;
            right: 100%;
            margin-top: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: transparent #555 transparent transparent;
          `;
        default: // top
          return `
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #555 transparent transparent transparent;
          `;
      }
    }}
  }
`;

export const Tooltip: React.FC<TooltipProps> = ({ content, children, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  const showTooltip = () => setVisible(true);
  const hideTooltip = () => setVisible(false);

  return (
    <TooltipWrapper onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {children}
      <TooltipText $visible={visible} $position={position}>
        {content}
      </TooltipText>
    </TooltipWrapper>
  );
};

export default Tooltip; 